export enum FundRequestTab {
  Active = 'active',
  Archived = 'archived',
}
